// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute = ({ children }) => {
  const { authReady } = useAuth();

  // While auth is resolving, render nothing (page content loads around it)
  if (!authReady) {
    return null;
  }

  // Always allow access — guest user is auto-created when not signed in
  return children;
};

export default PrivateRoute;
